import { Component, OnInit } from '@angular/core';
import { AuditTypeTableHelper } from './helpers/audit-type-table-helper';
import { AuditSummary, ILimitedResult, Pagination } from 'src/app/models';
import { AuditService, GlobalFilterService } from 'src/app/services';
import { ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { Table } from 'primeng/table';
import { SortEvent } from 'primeng/api';
const MAX_ROWS = 30;

@Component({
  selector: 'app-audit-type-summary',
  templateUrl: './audit-type-summary.component.html',
  styleUrls: ['./audit-type-summary.component.css']
})

export class AuditTypeSummaryComponent implements OnInit {

  @ViewChild('dt', { static: true }) dTable: Table;

  readonly auditTypeTableHelper: AuditTypeTableHelper;
  typeSummary: AuditSummary[];
  typeDataLoading: boolean;
  totalItemCount = MAX_ROWS;
  summaryAttribute = 'AuditType';

  constructor(private auditService: AuditService,
              private globalFilterService: GlobalFilterService) {
    this.auditTypeTableHelper = new AuditTypeTableHelper();
    globalFilterService.ClientChanged.subscribe(() => this.onClientsChanged());
  }

  onClientsChanged(): void {
    if (this.dTable) {
      this.dTable.reset();
      this.typeDataLoading = true;
    }
  }

  ngOnInit() {
    this.typeDataLoading = true;
  }

  getTypeSummary(pagination: Pagination, searchAttribute: string) {
    this.auditService.getAuditSummary(pagination, searchAttribute)
      .subscribe(
        (data: ILimitedResult<AuditSummary>) => {
          this.typeSummary = data.Items;
          this.typeDataLoading = false;
          this.totalItemCount = data.TotalItemCount;
        }
    );
  }

  loadDataLazy(event: LazyLoadEvent) {
    if (!this.typeDataLoading) {
      this.typeDataLoading = true;
    }
    this.getTypeSummary(new Pagination(MAX_ROWS, event.first, event.sortField, event.sortOrder), this.summaryAttribute);
  }

  refresh() {
    this.dTable.reset();
  }
}
